export default __webpack_public_path__ + "static/media/b8.d397068d.webp";